/** Open in new tab with most browsers support */
export function openInNewTab(href) {
  const a = document.createElement('a');
  a.href = href;
  a.target = '_blank';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
